import { Task } from 'app/agriculture/queries/tasks/types/Task';
import { isDateOverdue } from 'app/agriculture/routes/Tasks/utils/isDateOverdue';

export function isTaskOverdue({
    isComplete,
    endDate,
}: {
    isComplete: Task['isComplete'];
    endDate: Task['endDate'];
}) {
    if (isComplete) {
        return false;
    }

    return isDateOverdue(endDate);
}
